
export const USER_API: string = 'https://backoffice-api-cxwrw.ondigitalocean.app';
export const CORE_API: string = 'https://core-api-5y96y.ondigitalocean.app';
export const VERIFIER_APP: string = 'https://diplome.gov.gn';
export const FILE_PROCESSOR_API: string = 'https://jellyfish-app-qj5ov.ondigitalocean.app';